import { createContext, useContext, useState } from "react";

const ModifySearchContext = createContext();

export const ModifySearchProvider = ({ children }) => {
    const [countryNames, setCountryNames] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState("");

    const handleSearch = (country) => {
        
        setSelectedCountry(country)
    }

    return (
        <ModifySearchContext.Provider value={{ countryNames, setCountryNames, handleSearch, selectedCountry }}>
            {children}
        </ModifySearchContext.Provider>
    );
};

export const useModifySearch = () => {
    return useContext(ModifySearchContext);
};
